// Pantalla de inscripción enviada del formulario rediseñado (v2).
// El mensaje sale de la configuración (genérica Men_Ins_Fin, cargada en InscripcionAgregar como mensaje_final).
import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Button from "@material-ui/core/Button";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CheckIcon from "@material-ui/icons/Check";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";
import LanguageIcon from "@material-ui/icons/Language";
import emma_logo from "../../../global/imagenes/logo_agrupado_sinfondo.png";
import emma from "../../../global/imagenes/nueva_emma.png";
import { useEstilosInscripcion } from "./estilosInscripcion";
import { PieInscripcion } from "./componentesInscripcion";

const capitalizar = (texto = "") => texto ? texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase() : "";

export default function PantallaEnviada({ mensajeFinal, primerNombre, correo, celular, tipo, linkPolitica }) {
  const classes = useEstilosInscripcion();
  const nombre = capitalizar(primerNombre);
  return (
    <div className={classes.raiz}>
      <CssBaseline />
      <main className={`${classes.pagina} ${classes.cierrePagina}`}>
        <div className={`${classes.contenedor} ${classes.cierreContenedor}`}>
          <div className={classes.cabecera}>
            <div className={classes.marca}>
              <img src={emma_logo} alt="Logo Emma" className={classes.logoCabecera} />
              <span className={classes.separador} />
              <div>
                <p className={classes.titulo}>Inscripciones Unicosta</p>
                {tipo && <p className={classes.subtitulo}>{tipo}</p>}
              </div>
            </div>
          </div>

          <div className={classes.cierreCuerpo}>
            <div className={classes.cierreImagen}>
              <img src={emma} alt="Emma" />
            </div>
            <div>
              <span className={`${classes.cierreEtiqueta} ${classes.etiquetaExito}`}>
                <CheckCircleOutlineIcon style={{ fontSize: 14 }} />Inscripción enviada
              </span>
              <p className={classes.cierreTitulo}>
                {nombre ? `¡Listo, ${nombre}! ` : "¡Listo! "}Ya diste el primer paso para ser parte de la CUC
              </p>
              <p className={classes.cierreTexto}>{mensajeFinal}</p>
              {(correo || celular) && (
                <div className={classes.cierreContacto}>
                  <p className={classes.cierreContactoTitulo}>Nos contactaremos contigo</p>
                  {correo && (
                    <p className={classes.cierreContactoDato}>
                      <MailOutlineIcon className={classes.seccionIcono} style={{ fontSize: 16 }} />{correo}
                    </p>
                  )}
                  {celular && (
                    <p className={classes.cierreContactoDato} style={{ marginTop: 4 }}>
                      <PhoneIphoneIcon className={classes.seccionIcono} style={{ fontSize: 16 }} />{celular}
                    </p>
                  )}
                </div>
              )}
              <div className={classes.cierreAcciones}>
                <Button className={classes.botonPrincipal} startIcon={<CheckIcon />} href="/inscripcion">
                  Finalizar
                </Button>
                <Button className={classes.botonSecundario} startIcon={<LanguageIcon />} href="https://www.cuc.edu.co/" target="_blank" rel="noopener noreferrer">
                  Ir a cuc.edu.co
                </Button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <PieInscripcion linkPolitica={linkPolitica} />
    </div>
  );
}
